export default __webpack_public_path__ + "static/media/traveller-2.d5a55b85.jpg";